import React, { useRef, useState, useLayoutEffect } from 'react';
// iOS58 measures at width minus badge/gap, hiding E when the title exceeds its visible line limit.
export default function PlaylistItemTitle({ title, explicit }) {
  const row = useRef(null),
    natural = useRef(null),
    displayed = useRef(null);
  const [badge, setBadge] = useState(null);
  useLayoutEffect(() => {
    if (!explicit) return;
    let active = true;
    const measure = () => {
      if (!active || !row.current || !natural.current) return;
      const range = document.createRange();
      range.selectNodeContents(natural.current);
      const rects = [...range.getClientRects()],
        last = rects.at(-1),
        box = row.current.getBoundingClientRect();
      const zoom = box.width / row.current.offsetWidth || 1;
      const style = getComputedStyle(natural.current);
      const fontSize = parseFloat(style.fontSize) || 14;
      const lineHeight = parseFloat(style.lineHeight) || 19;
      const lines =
        parseInt(getComputedStyle(displayed.current).getPropertyValue('-webkit-line-clamp'), 10) ||
        2;
      const size = (fontSize * 10) / 14;
      const fits =
        natural.current.offsetHeight <= lineHeight * lines + 0.5 &&
        last &&
        last.right <= box.right + 1;
      const next = fits
        ? {
            left: (last.right - box.left) / zoom + 4,
            top: (last.top - box.top) / zoom + (last.height / zoom - size) / 2,
            width: size,
            height: size,
            fontSize: fontSize / 2,
            lineHeight: `${size}px`,
            borderRadius: size * 0.15,
          }
        : null;
      setBadge((old) => (JSON.stringify(old) === JSON.stringify(next) ? old : next));
    };
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(row.current);
    observer?.observe(natural.current);
    document.fonts?.ready.then(measure);
    return () => {
      active = false;
      observer?.disconnect();
    };
  }, [title, explicit]);
  return (
    <strong ref={row} className="pp-playlist-item-title">
      <span
        ref={displayed}
        className="pp-playlist-item-title-text"
        style={{ marginRight: badge ? badge.width + 4 : 0 }}
      >
        {title}
      </span>
      {explicit && (
        <span
          ref={natural}
          className="pp-playlist-title-measure"
          aria-hidden="true"
          style={{ width: 'calc(100% - 0.7142857143em - 4px)' }}
        >
          {title}
        </span>
      )}
      {explicit && badge && (
        <small className="pp-explicit" style={badge} aria-label="Explicit">
          E
        </small>
      )}
    </strong>
  );
}
